import axios from 'axios';
import i18next from 'i18next';
import { notification } from 'antd';
import store from 'redux/store';
import { updateUserStatus } from 'redux/reducers/userStatus';

const handleNetworkError = (message) => {
  notification.error({
    message: i18next.t('errors.networkError'),
    description: message ? `Message: ${message}` : null,
    duration: 10,
  });
};

const handleInternalServerError = (message, status) => {
  notification.error({
    message: `${i18next.t('errors.unexpectedError')} (Code: ${status})`,
    description: `Message: ${message}`,
    duration: 10,
  });
};

const handleUnauthorizedError = () => {
  store.dispatch(
    updateUserStatus({
      isAuthorized: false,
    }),
  );
};

const handleUnauthenticatedError = () => {
  store.dispatch(
    updateUserStatus({
      isAuthorized: false,
      isAuthenticated: false,
    }),
  );
};

const errorCallback = (e) => {
  const error = e.toJSON();

  if (!error.status) {
    handleNetworkError(error.message);
  } else if (error.status === 403) {
    handleUnauthorizedError();
  } else if (error.status === 401) {
    handleUnauthenticatedError();
  } else if (error.status >= 500 && error.status <= 599) {
    const message = i18next.t('errors.internalError'); // TODO: Récuperer le message d'erreur
    handleInternalServerError(message, error.status);
  }

  return Promise.reject(e);
};

axios.interceptors.request.use(undefined, errorCallback);
axios.interceptors.response.use(undefined, errorCallback);
